import routes from "./routes";
import store from "./store";

export default {
  install(Vue, options) {
    if (options.router) {
      options.router.addRoutes(routes);
    }

    if (options.store) {
      options.store.registerModule("Grievances", store);
      // options.store.commit("Dashboard/ADD_LINK", discLinks);
    }
  },
};
